import { NavLink, Outlet, useNavigate } from "react-router";
import { useAdminAuth } from "../context/admin-auth";

export function AdminLayout() {
	const { signOut } = useAdminAuth();
	const navigate = useNavigate();

	async function handleSignOut() {
		await signOut();
		navigate("/admin/sign-in", { replace: true });
	}

	return (
		<div className="min-h-screen bg-gray-50">
			<header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
				<span className="text-lg font-semibold text-gray-900">Apsu Admin</span>
				<button
					type="button"
					onClick={handleSignOut}
					className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
				>
					Sign Out
				</button>
			</header>
			<nav className="bg-white border-b border-gray-200 flex">
				<NavLink
					to="/admin"
					end
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Dashboard
				</NavLink>
				<NavLink
					to="/admin/tenants"
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Tenants
				</NavLink>
				<NavLink
					to="/admin/changelog"
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Changelog
				</NavLink>
				<NavLink
					to="/admin/audit-log"
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Audit Log
				</NavLink>
				<NavLink
					to="/admin/flags"
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Flags
				</NavLink>
				<NavLink
					to="/admin/rate-limits"
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Rate Limits
				</NavLink>
				<NavLink
					to="/admin/webhooks"
					className={({ isActive }) =>
						`px-4 py-2 text-sm font-medium ${isActive ? "text-blue-600 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"}`
					}
				>
					Webhooks
				</NavLink>
			</nav>
			<main className="p-4">
				<Outlet />
			</main>
		</div>
	);
}
